import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import { apiSignIn, apiSignOut, apiSignUp } from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import {PERSIST_STORE_NAME, REDIRECT_URL_KEY} from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'
import {getUser} from "../../services/UserService";
import deepParseJson from "../deepParseJson";
import {useAlert} from "react-alert";

function useAuth() {

    const dispatch = useDispatch()

    const navigate = useNavigate()

	const query = useQuery();

	const alert = useAlert();

    const { token, signedIn } = useSelector((state) => state.auth.session)

    const signIn = async (values) => {
        try {
			console.log(values);
			const resp = await apiSignIn(values, alert)
			console.log(resp);
			if (resp.data) {
				const { token, user, config, scope } = resp.data
				dispatch(onSignInSuccess({payload: token}))
				localStorage.setItem('token', token);

				dispatch(setUser({
					avatar: '',
					username: user,
					authority: [scope],
					email: user,
					config: config,
				}))

				const redirectUrl = query.get(REDIRECT_URL_KEY)
				navigate(redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath)
                return {
                    status: 'success',
                    message: ''
                }
			}
		} catch (errors) {
			console.log(errors);
			return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString()
            }
		}
    }

	const signUp = async (values) => {
        try {
			const resp = await apiSignUp(values, alert)
			if (resp.data) {
				const { token, user, config, scope } = resp.data
				dispatch(onSignInSuccess({payload: token}))

				dispatch(setUser({
					avatar: '',
					username: user,
					authority: [scope],
					email: user,
					config: config,
				}))

				const redirectUrl = query.get(REDIRECT_URL_KEY)
				navigate(redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath)
                return {
                    status: 'success',
                    message: ''
                }
			}
		} catch (errors) {
			return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString()
            }
		}
    }

    const handleSignOut = ()  => {
		dispatch(onSignOutSuccess())
		dispatch(setUser(initialState))
		navigate(appConfig.publicRoute)
	}

    const signOut = async () => {
		await apiSignOut()
		handleSignOut()
	}
    
    return {
        authenticated: token && signedIn,
        signIn,
		signUp,
        signOut
    }
}

export default useAuth